// Community Account Management APIs

/**
 * @function ApiClient#GetAccountList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAccountList(cid, options = {}) {
  return await this._get(`/community/${cid}/account_list`, options);
}

/**
 * @function ApiClient#RemoveCommunityAdmin
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} uid
 * @param {any} options = {}
 */
export async function RemoveCommunityAdmin(cid, uid, options = {}) {
  return await this._delete(`/community/${cid}/account/${uid}`, options);
}

/**
 * @function ApiClient#CreateCommunityAdmin
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} accountInfo
 * @param {any} options = {}
 */
export async function CreateCommunityAdmin(cid, accountInfo, options = {}) {
  return await this._post(`/community/${cid}/account`, accountInfo, options);
}

/**
 * @function ApiClient#UpdateCommunityAdmin
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} accountInfo
 * @param {any} options = {}
 */
export async function UpdateCommunityAdmin(cid, accountInfo, options = {}) {
  return await this._put(`/community/${cid}/account`, accountInfo, options);
}

// Role Management APIs
/**
 * @function ApiClient#GetAccountRoleList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAccountRoleList(cid, options = {}) {
  return await this._get(`/community/${cid}/account_role_list`, options);
}

/**
 * @function ApiClient#AddAccountRole
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} role
 * @param {any} options = {}
 */
export async function AddAccountRole(cid, role, options = {}) {
  return await this._post(`/community/${cid}/account_role`, role, options);
}

/**
 * @function ApiClient#UpdateAccountRole
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} role
 * @param {any} options = {}
 */
export async function UpdateAccountRole(cid, role, options = {}) {
  return await this._put(`/community/${cid}/account_role`, role, options);
}

/**
 * @function ApiClient#DeleteAccountRole
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} rid
 * @param {any} options = {}
 */
export async function DeleteAccountRole(cid, rid, options = {}) {
  return await this._delete(`/community/${cid}/account_role/${rid}`, options);
}
